import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: `${ environment.appname } - Your One-Stop Gaming Station`,
    loadComponent: () => import('./features/home/home.page').then(m => m.HomePage)
  },
  {
    path: 'watch',
    title: `${ environment.appname } - Watch`,
    loadComponent: () => import('@features/watch-deals/watch-deals.page').then(m => m.WatchDealsPage)
  },
  {
    path: 'deals',
    title: `${ environment.appname } - Deals`,
    loadComponent: () => import('@features/watch-deals/watch-deals.page').then(m => m.WatchDealsPage)
  },
  {
    path: 'profile',
    title: `${ environment.appname } - Profile`,
    loadComponent: () => import('./features/profile/profile.page').then(m => m.ProfilePage)
  },
  {
    path: 'search',
    title: `${ environment.appname } - Search`,
    loadComponent: () => import('./features/search/search.page').then(m => m.SearchPage)
  },
  {
    path: 'category/:key',
    title: `${ environment.appname } - Category`,
    loadComponent: () => import('./features/category/category.page').then(m => m.CategoryPage)
  },
  {
    path: 'tag/:key',
    title: `${ environment.appname } - Tag`,
    loadComponent: () => import('./features/tag/tag.page').then(m => m.TagPage)
  },
  {
    path: 'author/:key',
    title: `${ environment.appname } - Author`,
    loadComponent: () => import('./features/author/author.page').then(m => m.AuthorPage)
  },
  {
    path: 'article/:key',
    title: `${ environment.appname } - Article`,
    loadComponent: () => import('@app/features/article-detail/article-detail.page').then(m => m.ArticleDetailPage)
  },
  {
    path: 'cyber-media-guidelines',
    title: `${ environment.appname } - Cyber Media Guidelines`,
    loadComponent: () => import('./features/cyber-media-guidelines/cyber-media-guidelines.page').then(m => m.CyberMediaGuidelinesPage)
  },
  {
    path: 'copyright-disclaimer',
    title: `${ environment.appname } - Copyright Disclaimer`,
    loadComponent: () => import('./features/copyright-disclaimer/copyright-disclaimer.page').then(m => m.CopyrightDisclaimerPage)
  },
  {
    path: 'write-for-us',
    title: `${ environment.appname } - Write For Us`,
    loadComponent: () => import('./features/write-for-us/write-for-us.page').then(m => m.WriteForUsPage)
  },
  {
    path: 'about-us',
    title: `${ environment.appname } - About Us`,
    loadComponent: () => import('./features/about-us/about-us.page').then(m => m.AboutUsPage)
  },
  {
    path: '404',
    title: `${ environment.appname } - 404 Not Found!`,
    loadComponent: () => import('@core/pages/404/not-found.page').then(m => m.NotFoundPage)
  },
  {
    path: 'verification/:token',
    title: `${ environment.appname } - Verification`,
    loadComponent: () => import('@core/pages/redirect/redirect.page').then(m => m.RedirectPage)
  },
  {
    path: '**',
    redirectTo: '404'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', preloadingStrategy: NoPreloading }),
  ],
  exports: [ RouterModule ],
})
export class AppRoutingModule {}
